import * as React from "react";
import type { SvyBadgeProps } from "./SvyBadge.interface";
import { Container, LeftIcon, RightIcon } from "./SvyBadge.style";

export const SvyBadge = React.forwardRef<HTMLDivElement, SvyBadgeProps>((props, ref) => {
    const { elementLeft, elementRight, label } = props;

    return (
        <Container ref={ref} data-testid="svy-badge" {...props}>
            {elementLeft && <LeftIcon isSingleIcon={!label}>{elementLeft}</LeftIcon>}
            {label}
            {elementRight && <RightIcon>{elementRight}</RightIcon>}
        </Container>
    );
});

SvyBadge.displayName = "SvyBadge";
